import React, { FC, useState } from "react";
import { Helmet } from "react-helmet";
import SocialsList from "shared/SocialsList/SocialsList";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import toast from "react-hot-toast";
import { globalJson } from "global/global_json";
import { ContactFun } from "api/profile/profile";
import FAQ from "components/FAQ/FAQ";

export interface PageContactProps {
  className?: string;
  asSection?: boolean;
}

const contacts = [
  {
    id: 1,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2081_27376)">
          <path
            d="M14.3291 3.08241C13.2367 1.19719 11.2964 0.0454395 9.13864 0.00142383C9.04653 -0.000474609 8.95383 -0.000474609 8.86168 0.00142383C6.704 0.0454395 4.76366 1.19719 3.67121 3.08241C2.55458 5.0094 2.52403 7.32408 3.58948 9.27424L8.05302 17.4441C8.05502 17.4477 8.05703 17.4513 8.0591 17.4549C8.25548 17.7963 8.60729 18 9.00023 18C9.39314 18 9.74495 17.7962 9.9413 17.4549C9.94337 17.4513 9.94537 17.4477 9.94738 17.4441L14.4109 9.27424C15.4763 7.32408 15.4457 5.0094 14.3291 3.08241ZM9.00016 8.15627C7.60442 8.15627 6.46891 7.02076 6.46891 5.62502C6.46891 4.22928 7.60442 3.09377 9.00016 3.09377C10.3959 3.09377 11.5314 4.22928 11.5314 5.62502C11.5314 7.02076 10.3959 8.15627 9.00016 8.15627Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_2081_27376">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Office Location",
    detail: globalJson.address,
  },
  {
    id: 2,
    icon: (
      <svg
        width="15"
        height="18"
        viewBox="0 0 15 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.2947 14.394C14.3734 14.4951 14.4289 14.6042 14.4604 14.7217C14.5039 14.8843 14.5014 15.047 14.4526 15.2113C14.4041 15.375 14.3118 15.5152 14.1763 15.6311L13.5373 16.169C13.2869 16.3751 13.0266 16.5458 12.7565 16.6811C12.4863 16.8164 12.2053 16.9234 11.913 17.0017C11.443 17.1276 10.9579 17.1739 10.4573 17.1405C9.95679 17.1071 9.458 17.0009 8.96106 16.8221C8.46412 16.6434 7.97654 16.3965 7.49896 16.0822C7.02126 15.7675 6.5689 15.3953 6.14261 14.965C5.88214 14.7329 5.60174 14.4635 5.30099 14.1571C5.04587 13.8959 4.74995 13.5804 4.41271 13.2104C4.07558 12.8409 3.72397 12.424 3.35738 11.9614C2.98561 11.4997 2.67933 11.0915 2.43896 10.7368C2.19848 10.3816 2.00618 10.0846 1.8629 9.84546C1.69529 9.56626 1.56626 9.3229 1.47591 9.11579C1.24941 8.7469 1.05474 8.37174 0.8923 7.99021C0.729864 7.60868 0.596744 7.22337 0.49263 6.83481C0.35649 6.32673 0.27666 5.82439 0.252491 5.32705C0.228321 4.8297 0.267883 4.35059 0.370332 3.88994C0.472781 3.42928 0.643255 2.99612 0.881752 2.59045C1.12025 2.18478 1.43383 1.82282 1.82227 1.50372L2.45396 0.979117C2.55455 0.900106 2.66213 0.845477 2.77617 0.814922C2.93666 0.771918 3.09805 0.776203 3.26046 0.828199C3.42244 0.880309 3.55927 0.975372 3.67021 1.11404L5.90043 3.89109C5.97955 3.99211 6.03418 4.09969 6.06474 4.21373C6.10966 4.3814 6.10812 4.54794 6.05967 4.71347C6.01123 4.879 5.91823 5.01844 5.78013 5.1315L4.53035 6.16891C4.36518 6.30597 4.25511 6.47126 4.19952 6.66586C4.14435 6.86036 4.14242 7.05416 4.19425 7.2476C4.23363 7.39457 4.29809 7.52532 4.38816 7.64016L8.16027 12.357C8.30703 12.5382 8.47383 12.6555 8.6615 12.7089C8.84875 12.7624 9.03788 12.7638 9.22794 12.7128C9.3576 12.6781 9.48187 12.6131 9.60087 12.5183L10.8506 11.4809C10.9501 11.4026 11.0567 11.3478 11.1707 11.3173C11.3279 11.2752 11.4884 11.2797 11.6521 11.3313C11.8158 11.383 11.954 11.4767 12.0666 11.6132L14.2947 14.394Z"
          fill="white"
        />
      </svg>
    ),
    title: "Phone",
    detail: globalJson.phone,
  },
  {
    id: 3,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2081_27354)">
          <path
            d="M17.8418 3.57422L12.3828 8.99809L17.8418 14.422C17.9405 14.2157 18.0004 13.9877 18.0004 13.7442V4.252C18.0004 4.00847 17.9405 3.78048 17.8418 3.57422Z"
            fill="white"
          />
          <path
            d="M16.418 2.67188H1.58207C1.33855 2.67188 1.11056 2.73175 0.904297 2.83043L7.88151 9.7725C8.49843 10.3894 9.50165 10.3894 10.1186 9.7725L17.0958 2.83043C16.8895 2.73175 16.6615 2.67188 16.418 2.67188Z"
            fill="white"
          />
          <path
            d="M0.158555 3.57422C0.0598711 3.78048 0 4.00847 0 4.252V13.7442C0 13.9877 0.0598711 14.2157 0.158555 14.422L5.61758 8.99809L0.158555 3.57422Z"
            fill="white"
          />
          <path
            d="M11.6368 9.74609L10.8643 10.5186C9.83634 11.5465 8.16371 11.5465 7.13578 10.5186L6.36332 9.74609L0.904297 15.17C1.11056 15.2686 1.33855 15.3285 1.58207 15.3285H16.418C16.6615 15.3285 16.8895 15.2686 17.0958 15.17L11.6368 9.74609Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_2081_27354">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Email",
    detail: globalJson.email,
  },
];

const PageContact: FC<PageContactProps> = ({
  className = "",
  asSection = false,
}) => {
  const [getEmail, setEmail] = useState("");
  const [newName, setNewName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendEmail = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!getEmail.trim() || !emailRegex.test(getEmail)) {
      toast.error("Please enter a valid email address");
      setLoading(false);
      return;
    }

    if (getEmail.length === 0 || newName.length === 0 || message.length === 0) {
      toast.error("Fields are required!");
      setLoading(false);
      return;
    }

    // Create the payload with name, email, and message
    const payload = {
      name: newName,
      email: getEmail,
      message: message,
    };

    const result = await ContactFun(payload);

    if (result.error) {
      toast.error(result.error);
    } else {
      toast.success("Sent successfully!");
      setEmail("");
      setNewName("");
      setMessage("");
    }

    setLoading(false);
  };

  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      {!asSection && (
        <Helmet>
          <title>Contact</title>
        </Helmet>
      )}
      <div className="container mx-auto">
        <div className="flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-12  rounded-lg py-16 px-12 bg-primary-gradient  mt-12">
          <div className="mt-8 ">
            <span className="font-bold text-lg ">Contact Us</span>
            <h2 className="text-5xl font-semibold mt-12">Let's talk with Us</h2>
            <div className="flex flex-col mt-6">
              <div className=" space-y-6">
                <span className="text-xl font-bold">Contact Info :</span>
                {contacts.map((contact) => (
                  <div key={contact.id} className="flex items-center space-x-4">
                    {/* Icon */}
                    <div className="flex items-center justify-center  ">
                      {contact.icon}
                    </div>

                    {/* Text */}
                    <div>
                      <p className="text-white text-lg font-semibold">
                        {contact.title}
                      </p>
                      <p className="text-[#FFFFFFCC] text-sm font-medium">
                        {contact.detail}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div>
            <div className="py-4"></div>
            <form
              className="grid grid-cols-1 gap-6 bg-[#121212] p-12 rounded-lg"
              onSubmit={sendEmail}
            >
              <label className="block">
                <Input
                  placeholder="Name"
                  type="text"
                  className="mt-1"
                  value={newName}
                  onChange={(e) => {
                    setNewName(e.target.value);
                  }}
                />
              </label>
              <label className="block">
                <Input
                  type="email"
                  placeholder="Email"
                  className="mt-1"
                  value={getEmail}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </label>
              <label className="block">
                <Textarea
                  className="mt-1"
                  placeholder="Message"
                  rows={6}
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                />
              </label>
              <div>
                <ButtonPrimary type="submit" className="min-w-[200px]">
                  {loading ? (
                    <div className="flex justify-center items-center col-span-full">
                      <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
                    </div>
                  ) : (
                    "Send Message"
                  )}
                </ButtonPrimary>
              </div>
            </form>
          </div>
        </div>
        <div>
          <FAQ />
        </div>
      </div>
    </div>
  );
};

export default PageContact;
